// 語音文字轉數字解析器（國語/台語）— 與後端 voice_parser.py 邏輯一致

const CN_TO_ARABIC = {
  零: 0, 一: 1, 二: 2, 三: 3, 四: 4,
  五: 5, 六: 6, 七: 7, 八: 8, 九: 9,
}

const UNITS = { 十: 10, 百: 100, 千: 1000, 萬: 10000 }

const DIALECT_MAP = { 兩: 2, 二: 2 }

const NOISE_PATTERN = new RegExp(
  '血壓|收縮壓|舒張壓|上壓|下壓|心跳|打|下|體重|公斤|公克|洗水|洗液|第|次|' +
    '睏前|睡前|起床|血糖|速效|長效|單元|單位|號|今天|昨天|明天|我會|還有|差不多|' +
    '點點|元|個|u|的|啊|啦|喔|嘛|一下',
  'g'
)

export const FIELD_KEYWORDS = {
  ultrafiltration: ['洗水', '洗液', '脫水'],
  morning_blood_sugar: ['起床'],
  bedtime_blood_sugar: ['睏前', '睡前'],
  insulin_rapid: ['速效'],
  insulin_long: ['長效'],
  heart_rate: ['心跳', '心搏'],
  weight: ['體重', '公斤'],
  blood_pressure_sys: ['血壓', '收縮壓', '上壓'],
  blood_pressure_dia: ['舒張壓', '下壓'],
}

export function detectField(text) {
  if (!text) return null
  for (const [field, keywords] of Object.entries(FIELD_KEYWORDS)) {
    for (const kw of keywords) {
      if (text.includes(kw)) return field
    }
  }
  return null
}

function cleanNoise(text) {
  return text.replace(NOISE_PATTERN, '')
}

function cnInt(text) {
  text = text.trim()
  if (!text) return null
  if (/^\d+$/.test(text)) return parseInt(text, 10)

  const chars = [...text]
  if (chars.every((ch) => ch in CN_TO_ARABIC || /[0-9]/.test(ch))) {
    return parseInt(
      chars.map((ch) => (ch in CN_TO_ARABIC ? CN_TO_ARABIC[ch] : parseInt(ch, 10))).join(''),
      10
    )
  }

  let total = 0
  let number = 0
  let lastUnit = null
  for (const ch of chars) {
    if (ch === '零') {
      number = 0
      lastUnit = null
    } else if (ch in CN_TO_ARABIC) {
      number = CN_TO_ARABIC[ch]
    } else if (ch in DIALECT_MAP) {
      number = DIALECT_MAP[ch]
    } else if (ch in UNITS) {
      const unit = UNITS[ch]
      if (number === 0) number = 1
      total += number * unit
      number = 0
      lastUnit = unit
    } else if (/[0-9]/.test(ch)) {
      number = parseInt(ch, 10)
    }
  }
  if (number > 0) {
    if (lastUnit === 100) total += number * 10
    else if (lastUnit === 1000) total += number * 100
    else if (lastUnit === 10000) total += number * 1000
    else total += number
  }
  return total > 0 ? total : null
}

export function extractVoiceValue(text) {
  if (!text || !text.trim()) return null
  const m = text.match(/\d+(?:\.\d+)?/)
  if (m) return parseFloat(m[0])

  let cleaned = cleanNoise(text)
  cleaned = cleaned.replace(/點仔/g, '.').replace(/點/g, '.')
  cleaned = cleaned.replace(/兩/g, '2')

  if (cleaned.includes('.')) {
    const [intPart, decPart] = cleaned.split('.', 2)
    const integerPart = intPart ? cnInt(intPart) : 0
    if (integerPart === null) return null
    let dec = ''
    for (const ch of [...(decPart || '')]) {
      if (ch in CN_TO_ARABIC) dec += String(CN_TO_ARABIC[ch])
      else if (/[0-9]/.test(ch)) dec += ch
      else break
    }
    return dec ? parseFloat(`${integerPart}.${dec}`) : integerPart
  }
  return cnInt(cleaned)
}
